import { render, staticRenderFns } from "./GoodsView.vue?vue&type=template&id=5d9d825e&"
import script from "./GoodsView.vue?vue&type=script&lang=js&"
export * from "./GoodsView.vue?vue&type=script&lang=js&"
import style0 from "./GoodsView.vue?vue&type=style&index=0&id=5d9d825e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports